var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMagicWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.954 2.743L3.049 3.809l1.067-1.904L3.049 0l1.905 1.067L6.858 0 5.792 1.905l1.066 1.904-1.904-1.066zm9.142 7.465L16 9.142l-1.066 1.904L16 12.951l-1.905-1.067-1.904 1.067 1.066-1.905-1.066-1.904 1.904 1.066zM16 0l-1.066 1.905L16 3.809l-1.905-1.066-1.904 1.066 1.066-1.904L12.191 0l1.904 1.067L16 0zM9.403 8.212l1.858-1.858-1.615-1.616-1.858 1.86 1.615 1.614zm.784-4.182l1.783 1.783c.297.282.297.777 0 1.074l-8.89 8.89c-.297.297-.793.297-1.075 0L.223 13.995c-.297-.282-.297-.777 0-1.075l8.89-8.89c.297-.297.792-.297 1.074 0z",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagicWhite);
export default __webpack_public_path__ + "static/media/magic-White.c022b55a8bda5127b767a9a3528e2f38.svg";
export { ForwardRef as ReactComponent };